import React from 'react';
import { connect } from 'react-redux';
import { AppState, IPageState } from '../../appredux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    open: boolean,
    closeDialog: () => void,
    tytul: string,
}

interface DialogState {
    //open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            //open: false
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        //if(this.props.page.openDialogError !== prevProps.page.openDialogError){
        //    this.setState({open: true})
        //}
    }


    render() {
        const classes = this.props.classes;
       
        return (
            <>
                <Dialog
                    maxWidth="xs"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.closeDialog}
                    onBackdropClick={this.props.closeDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography style={{}}>
                        <Typography gutterBottom variant="h6" component="h2" color='primary'
                            className={`${classes.headline}`}><b style={{ }}>{this.props.tytul}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>

                        <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ex massa, luctus et urna a, consequat faucibus mi. Nam libero ipsum, luctus at interdum in, pulvinar quis orci. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Quisque orci orci, scelerisque vulputate lorem at, consectetur vulputate mi. Vivamus faucibus in velit at interdum. Nam porta tristique aliquet. Duis cursus nisi consectetur urna blandit egestas. Praesent et dolor vitae dolor pretium molestie. Suspendisse potenti.
                        </DialogContentText>
                        <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
                            Nam molestie molestie justo vel finibus. Mauris mollis, mauris eu elementum vestibulum, nisl metus sagittis nunc, nec consectetur diam ligula ut dolor. Proin lacinia purus auctor erat dapibus ullamcorper. Phasellus euismod mi a libero posuere, vel elementum nulla vulputate. Vestibulum eget ligula vel nisl dapibus facilisis. Phasellus vitae vehicula massa, ut tristique ex. Suspendisse sollicitudin ex eu nisl aliquet iaculis. Donec fringilla lobortis dolor, sed tincidunt ligula facilisis vitae. Nulla ut turpis at erat laoreet fringilla in non velit. Proin porttitor, erat quis finibus pretium, tellus nulla interdum turpis, non suscipit leo dui eget odio. Quisque tristique magna non purus mollis, et consequat est tempus. Curabitur commodo magna lorem, sed porta felis euismod a. Curabitur placerat porttitor massa at dignissim. Morbi sem leo, aliquet et sem nec, egestas porta dui. Suspendisse potenti.
                        </DialogContentText>
                        <DialogContentText className={`${classes.dialogContentText} ${classes.paddingLeft}`} >
                            Cras varius, velit id hendrerit commodo, lorem libero mattis diam, vel dignissim quam magna quis enim. Vivamus interdum eros fringilla scelerisque convallis. Ut vel purus elementum eros interdum maximus eget at risus. Vestibulum efficitur accumsan elit at tincidunt. Etiam imperdiet iaculis odio ac mattis. Integer id sapien at massa congue egestas at vitae augue. Praesent et enim at magna interdum aliquet vel sit amet leo. Mauris rutrum suscipit egestas. In et ipsum fermentum, consequat orci eget, suscipit urna. Praesent at pellentesque tellus. Cras id tortor pulvinar nunc feugiat volutpat. Morbi fringilla ex in metus pharetra pellentesque. Nullam odio magna, porta vitae elementum vel, fringilla ut urna. Nunc et facilisis nisl.
                        </DialogContentText>  
                      
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.closeDialog}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        //paddingLeft: "20px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        textAlign: "justify" as "justify",
        //whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

